import React from "react";

import { strings } from "@perceptron/constants";
import { Button } from "@perceptron/ui/components/button";
import { Icon } from "@perceptron/ui/components/icon";
import { formatString } from "@perceptron/utils/string";

interface ImageNavigationProps {
  currentIndex: number;
  totalImages: number;
  onNavigate: (newIndex: number) => void;
}

export function ImageNavigation({ currentIndex, totalImages, onNavigate }: ImageNavigationProps) {
  if (totalImages <= 1) return null;

  const handleNavigation = (direction: "left" | "right") => {
    if (direction === "left") {
      onNavigate(currentIndex > 0 ? currentIndex - 1 : totalImages - 1);
    } else {
      onNavigate(currentIndex < totalImages - 1 ? currentIndex + 1 : 0);
    }
  };

  return (
    <>
      <div className="pointer-events-none absolute inset-0 flex items-center justify-between p-4 opacity-0 transition-opacity group-hover/image-viewer:opacity-100">
        <div className="pointer-events-auto relative z-50">
          <Button
            aria-label={strings.ariaLabels.leftNavigationButton}
            className="cursor-pointer rounded-full bg-black/60 text-white shadow-lg transition-opacity hover:opacity-100"
            size="icon"
            variant="ghost"
            onClick={() => handleNavigation("left")}
          >
            <Icon className="h-6 w-6" name="chevron-left" />
          </Button>
        </div>
        <div className="pointer-events-auto relative z-50">
          <Button
            aria-label={strings.ariaLabels.rightNavigationButton}
            className="cursor-pointer rounded-full bg-black/60 text-white shadow-lg transition-opacity hover:opacity-100"
            size="icon"
            variant="ghost"
            onClick={() => handleNavigation("right")}
          >
            <Icon className="h-6 w-6" name="chevron-right" />
          </Button>
        </div>
      </div>
      <div className="absolute bottom-4 left-1/2 z-20 -translate-x-1/2 rounded-lg bg-black/50 px-3 py-1.5 text-sm text-white backdrop-blur-sm">
        {formatString(strings.common.counter, currentIndex + 1, totalImages)}
      </div>
    </>
  );
}
